<template>
  <div class="comp-container">
    <div class="box">
      <div
        class="nav-item"
        :class="`${nav.key == activeTab ? 'active' : ''} ${
          !!nav.subNavList ? 'has-sub' : ''
        }`"
        v-for="(nav, index) in navList"
        :key="index"
      >
        <div class="nav-btn" @click="switchNav(nav)">
          <span>{{ nav.name }}</span>
        </div>
        <div
          class="sub-nav"
          v-if="!!nav.subNavList && nav.key == activeTab"
          ref="subNav"
        >
          <div
            class="sub-nav-item"
            :ref="
              subNav.key == subActiveTab ? 'activeSubNavItem' : 'subNavItem'
            "
            @click="switchSubNav(subNav)"
            :class="subNav.key == subActiveTab ? 'active' : ''"
            v-for="(subNav, subIndex) in nav.subNavList"
            :key="subIndex + '' + subNav.key"
          >
            <autoTitle
              runTimeSecondLenght="5"
              textAlign="center"
              :static="subNav.key != subActiveTab"
            >
              <template
                v-if="subNav.colorTextList && subNav.colorTextList.length"
                ><span
                  v-for="(textObj, index) in subNav.colorTextList"
                  :key="index"
                  :style="textObj.color ? `color:${textObj.color}` : ''"
                  >{{ textObj.text }}</span
                ></template
              >
              <template v-else>{{ subNav.name }}</template>
            </autoTitle>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axios, webSocket } from "../../../../common";
import { mapState, mapGetters } from "vuex";
import AutoTitle from "../../../../components/autoTitle";

export default {
  name: "gamblePageNav",
  props: {
    navList: {},
    activeTab: {},
    subActiveTab: {},
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["userData"]),
  },
  watch: {},
  methods: {
    switchNav(item) {
      this.$emit("update:activeTab", item.key);
      this.$emit("changeTab", item.key);
      if (item.subNavList) {
        this.$emit("update:subActiveTab", item.subNavList[0].key);
      } else {
        if (this.subActiveTab) {
          this.$emit("update:subActiveTab", undefined);
        }
      }
    },
    switchSubNav(item) {
      if (item.disabled) {
        this.$emit("clickDisabledSubTab", item.key);
        return;
      }
      this.$emit("update:subActiveTab", item.key);
    },
    focusNav() {
      if (this.$refs.subNav && this.$refs.subNav[0]) {
        if (this.$refs.activeSubNavItem && this.$refs.activeSubNavItem[0]) {
          this.$refs.subNav[0].scrollTop =
            this.$refs.activeSubNavItem[0].offsetTop;
        }
      }
    },
  },
  components: {
    AutoTitle,
  },
  mounted() {},
  created() {},
};
</script>

  <style lang="scss" scoped>
.comp-container {
  $nav-width: 1.9rem;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  padding-top: 0.2rem;
  padding-bottom: 0.3rem;
  width: $nav-width;
  // height: 100%;
  background: url(./imgs/nav-bg-2.png);
  background-size: 100% 100%;
  .box {
    height: 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  .nav-item {
    margin-bottom: 0.04rem;
    display: flex;
    flex-direction: column;
    min-height: $nav-width/2.5;
    font-weight: 600;

    &.active {
      &.has-sub {
        margin-bottom: 0;
        // flex: 1;
      }

      .nav-btn {
        border-top: 0;
        background-image: url(./imgs/nav-item-active.png);
        // background-image: url(~@/assets/sub-nav-item-active.png);
        span {
          /* background-color: #292829;
          background-image: none; */
          background-image: -webkit-linear-gradient(top, #5c1413, #e04445);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
    .nav-btn {
      width: $nav-width;
      height: $nav-width/2.5;
      flex-shrink: 0;
      font-size: 0.23rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-top: 2px solid rgba(#ccad7e, 1);
      background-color: rgba(#745534, 0.5);
      // background: url(./imgs/nav-item.png);
      // background-image: url(~@/assets/sub-nav-item.png);
      background-size: 100% 100%;

      span {
        color: #fff;
      }
    }
    .sub-nav {
      // flex: 1;
      position: relative;
      // background: url(./imgs/sub-nav-bg.png);
      background-size: 100% 100%;
      min-height: 0;
      overflow: auto;
      .sub-nav-item {
        width: $nav-width;
        height: $nav-width/2.7;
        padding: 0.1rem 0;
        font-size: 0.2rem;
        font-weight: 500;
        // color: #bbb;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;

        &.active {
          // background: url(./imgs/sub-nav-item-active.png);
          background-size: 100% 100%;
          color: #fff;

          position: relative;
          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;

            background: url(./imgs/sub-nav-selected.png) no-repeat;
            background-size: 100% auto;
            background-position: bottom;
          }

          /* &::before {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-image: linear-gradient(
              bottom,
              rgba(#ffd737, 0.7),
              rgba(#ffd737, 0) 0.6
            );
            animation: flash 1.5s infinite linear;
          }
          @-webkit-keyframes flash {
            0% {
              opacity: 0;
            }
            50% {
              opacity: 1;
            }
            100% {
              opacity: 0;
            }
          } */
        }
      }
    }
  }
}
</style>
